import { createAsyncThunk } from "@reduxjs/toolkit";

import expertsCountryService from "services/expertsCountry";

export const fetchCountryWiseExperts = createAsyncThunk(
  "get/countryWiseExperts",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await expertsCountryService.fetchCountryWiseExperts(
        data
      );
      return response.data?.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);
